import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { LotteryPrice } from '../../types';
import styles from './ShippingAlert.module.scss';

function ShippingAlert({
  price,
  additionalShippingFeePerTimes,
  shippingFee,
  additionalShippingFee,
}: {
  price: LotteryPrice;
  additionalShippingFeePerTimes?: number;
  shippingFee: string;
  additionalShippingFee: string;
}) {
  return (
    <div className={`${styles.shippingAlert} ${utilsStyles.textSmall}`}>
      <span>{message(price, shippingFee, additionalShippingFee, additionalShippingFeePerTimes)}</span>
    </div>
  );
}

function message(
  price: LotteryPrice,
  shippingFee: string,
  additionalShippingFee: string,
  additionalShippingFeePerTimes?: number,
) {
  if (price.additionalShippingFee > 0 && price.shippingFee > 0) {
    return `配送手数料として初回${shippingFee}coinと初回以降
    ${additionalShippingFeePerTimes}回ごとに
    ${additionalShippingFee}coinがかかります。`;
  }
  if (price.additionalShippingFee > 0) {
    return `配送手数料として初回以降${additionalShippingFeePerTimes}回ごとに
    ${additionalShippingFee}coinがかかります。`;
  }
  return `初回のみ配送手数料として+${shippingFee}coinがかかります。`;
}

export default ShippingAlert;
